export const SLOTS_COUNT = 4
export const STEPS_COUNT = 10

export const enum GameState {
  Won,
  InProgress,
  Lost,
}

export enum Color {
  Grey = 'grey',
  Green = 'green',
  Blue = 'blue',
  Purple = 'purple',
  Pink = 'pink',
  Yellow = 'yellow',
  Orange = 'orange',
  Red = 'red',
}
